import { render, staticRenderFns } from "./ShareBtns.vue?vue&type=template&id=e0875c60&scoped=true&"
import script from "./ShareBtns.vue?vue&type=script&lang=js&"
export * from "./ShareBtns.vue?vue&type=script&lang=js&"
import style0 from "./ShareBtns.vue?vue&type=style&index=0&id=e0875c60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0875c60",
  null
  
)

export default component.exports